module.exports = __webpack_public_path__ + "static/media/pairs.a54c8ff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/types/pairs.png
// module id = 76
// module chunks = 0